"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdTabs = _interopRequireDefault(require("cccisd-tabs"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _Settings = _interopRequireDefault(require("../Settings"));
var _SyncSchools = _interopRequireDefault(require("../SyncSchools"));
var _ConfigureSchools = require("../ConfigureSchools");
var _SyncClasses = _interopRequireDefault(require("../SyncClasses"));
var _clever = _interopRequireDefault(require("./clever.svg"));
var _style = _interopRequireDefault(require("../style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CleverComponent = function CleverComponent(props) {
  var row = props.row;
  return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: "Clever Config - ".concat(row['group.label']),
    trigger: /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
      title: "Clever Sync/Configuration"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: 'btn btn-default ' + _style["default"].cleverButton
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: _clever["default"],
      alt: "clever icon"
    }))),
    render: function render(_ref) {
      var closeModal = _ref.closeModal;
      var tabList = [{
        name: 'settings',
        title: 'Settings',
        content: /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].tabWrapper
        }, /*#__PURE__*/_react["default"].createElement(_Settings["default"], _extends({}, props, {
          closeModal: closeModal,
          defaultValues: {
            cleverDistrictId: ''
          },
          renderFields: function renderFields() {
            return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              name: "cleverDistrictId",
              component: _cccisdFormik.CccisdInput,
              label: "Clever District ID"
            }));
          }
        })))
      }, {
        name: 'syncSchools',
        title: 'Sync Schools',
        content: /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].tabWrapper
        }, /*#__PURE__*/_react["default"].createElement(_SyncSchools["default"], _extends({}, props, {
          closeModal: closeModal
        })))
      }, {
        name: 'configureSchools',
        title: 'Configure Schools',
        content: /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].tabWrapper
        }, /*#__PURE__*/_react["default"].createElement(_ConfigureSchools.AutoRosterConfigureSchools, _extends({}, props, {
          closeModal: closeModal
        })))
      }, {
        name: 'syncClasses',
        title: 'Sync Classes',
        content: /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].tabWrapper
        }, /*#__PURE__*/_react["default"].createElement(_SyncClasses["default"], _extends({}, props, {
          closeModal: closeModal
        })))
      }];
      return /*#__PURE__*/_react["default"].createElement(_cccisdTabs["default"], {
        tabList: tabList
      });
    }
  });
};
CleverComponent.propTypes = {
  row: _propTypes["default"].shape({
    'group.groupId': _propTypes["default"].number.isRequired,
    'group.label': _propTypes["default"].string.isRequired,
    'group.settings.cleverDistrictId': _propTypes["default"].string,
    'group.settings.nightlySync': _propTypes["default"].bool
  }).isRequired,
  loadData: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = CleverComponent;